import { createSlice } from '@reduxjs/toolkit';
import { actions } from './employee.actions';
import { IEmployeeInitial } from './employee.types';

const initialState: IEmployeeInitial = {
  total: 0,
  isLoading: false,
  currentPage: 1,
  filters: {
    search: '',
    status: '',
  },
  currentEmployee: {
    id: '',
    project: '',
    isActive: false,
    personalInformation: {
      firstName: '',
      lastName: '',
      fullNameUa: '',
      birthDate: '',
    },
    contact: {
      corporateMail: '',
      phoneNumber: {
        code: '',
        phone: '',
      },
      payoneerID: '',
    },
    privateEntrepreneurInformation: {
      companyName: '',
      registrationCountry: {
        id: '',
        code: '',
      },
      registrationNumber: '',
      registrationDate: '',
      taxIdentificationNumber: '',
      addressEn: '',
      addressUa: '',
    },
    bankDetails: {
      country: {
        id: '',
        name: '',
      },
      currency: '',
      bankAccount: '',
      bankNameUa: '',
      bankNameEn: '',
      bankAddressUa: '',
      bankAddressEn: '',
      bankCode: '',
      openAccountDate: '',
    },
  },
  employees: [],
};

const employeeSlice = createSlice({
  name: 'employeeSlice',
  initialState,
  reducers: actions,
});

export const employeeReducer = employeeSlice.reducer;
export const {
  setCurrentPage,
  setCurrentEmployee,
  setFilters,
  updatePersonalDetails,
  updateContactDetails,
  updateBankDetails,
  updateEntrepreneurDetails,
} = employeeSlice.actions;
